import { Injectable } from '@angular/core';
import * as XLSX from 'xlsx';
import { ToastService, toastTypeEnum } from '../../Util/Toast/toast.service';
import { HttpClient } from '@angular/common/http';
import { SessionService } from '../../Util/Session/session.service';
import { environment } from '../../../environments/environment';
import { map } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class DownloadSampleService {

  constructor(private toast: ToastService,
    private http: HttpClient,
    private session: SessionService,
  ) { }

  // exportInChunks(data: any[], filename: string): void {  
  //  const chunkSize = 50000;
  //   const totalChunks = Math.ceil(data.length / chunkSize);
  //   const workbook = XLSX.utils.book_new();
  //   for (let i = 0; i < totalChunks; i++) {
  //     const chunk = data.slice(i * chunkSize, (i + 1) * chunkSize);
  //     const worksheet = XLSX.utils.json_to_sheet(chunk);
  //     XLSX.utils.book_append_sheet(workbook, worksheet, `Sheet${i + 1}`);
  //   }
  //   XLSX.writeFile(workbook, filename + ".xlsx");
  // }

  exportInChunks(data: any[], filename: string): void {
    const chunkSize = 50000;
    const totalChunks = Math.ceil(data.length / chunkSize);
    const workbook = XLSX.utils.book_new();

    for (let i = 0; i < totalChunks; i++) {
      const chunk = data.slice(i * chunkSize, (i + 1) * chunkSize);
      const worksheet = XLSX.utils.json_to_sheet(chunk);

      // 🔹 Autofit column widths
      const objectMaxLength: number[] = [];
      const keys = Object.keys(chunk[0] || {});

      chunk.forEach(row => {
        keys.forEach((key, colIdx) => {
          const value = row[key] ? String(row[key]) : '';
          const length = value.length;
          objectMaxLength[colIdx] = Math.max(objectMaxLength[colIdx] || key.length, length);
        });
      });
      worksheet['!cols'] = objectMaxLength.map(width => ({ wch: width + 2 })); // +2 for padding
      XLSX.utils.book_append_sheet(workbook, worksheet, `Sheet${i + 1}`);
    }
    XLSX.writeFile(workbook, `${filename}.xlsx`);
  }

  exportToExcel(DataTable: any[], filename: string, DataTable2: any[] = [], DataTable3: any[] = []): void {
    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.json_to_sheet(DataTable);
    const worksheet2 = XLSX.utils.json_to_sheet(DataTable2);
    const worksheet3 = XLSX.utils.json_to_sheet(DataTable2);
    const colWidths: number[] = Object.keys(DataTable[0]).map(key => key.length + 2);
    DataTable.forEach(row => {
      Object.keys(row).forEach((key, index) => {
        const value = row[key];
        const cellLength = value ? String(value).length + 2 : 10;
        colWidths[index] = Math.max(colWidths[index], cellLength);
      });
    });

    if (DataTable2.length > 0) {
      DataTable2.forEach(row => {
        Object.keys(row).forEach((key, index) => {
          const value = row[key];
          const cellLength = value ? String(value).length + 2 : 10;
          colWidths[index] = Math.max(colWidths[index], cellLength);
        });
      });
    }

    if (DataTable3.length > 0) {
      DataTable3.forEach(row => {
        Object.keys(row).forEach((key, index) => {
          const value = row[key];
          const cellLength = value ? String(value).length + 2 : 10;
          colWidths[index] = Math.max(colWidths[index], cellLength);
        });
      });
    }

    worksheet['!cols'] = colWidths.map(width => ({ width }));
    if (DataTable2.length > 0) {
      worksheet2['!cols'] = colWidths.map(width => ({ width }));
    }
    if (DataTable3.length > 0) {
      worksheet3['!cols'] = colWidths.map(width => ({ width }));
    }
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
    
    if (DataTable2.length > 0) {
      XLSX.utils.book_append_sheet(workbook, worksheet2, 'Sheet2');
    }
    if (DataTable3.length > 0) {
      XLSX.utils.book_append_sheet(workbook, worksheet3, 'Sheet3');
    }
    const dataURL = XLSX.write(workbook, { type: 'base64' });

    const blob = this.base64toBlob(dataURL, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = filename + ".xlsx";
    link.click();
  }

  // exportToExcel(DataTable: any[], filename: string): void {
  //   const workbook = new ExcelJs.Workbook();
  //   const worksheet = workbook.addWorksheet('Sheet1');
  //   // Adding headers
  //   worksheet.columns = Object.keys(DataTable[0]).map(key => ({ header: key, key }));
  //   // Adding rows
  //   // DataTable.forEach(row => worksheet.addRow(row));
  //   const rows = DataTable.map(row => Object.values(row)); // Convert each row to an array
  //   worksheet.addRows(rows); // Add multiple rows at once

  //   // Adjust column widths
  //   // worksheet.columns.forEach(column => {
  //   //     const maxLength = column.values.reduce((acc, val) => Math.max(acc, val ? String(val).length : 0), 0);
  //   //     column.width = maxLength + 2; // Add some padding
  //   // });

  //   // Write to file
  //   workbook.xlsx.writeBuffer().then(buffer => {
  //     const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  //     const link = document.createElement('a');
  //     link.href = URL.createObjectURL(blob);
  //     link.download = filename + ".xlsx";
  //     link.click();
  //   });
  // }

  // exportToExcel(DataTable: any[], filename: string): void {
  //   const workbook = XLSX.utils.book_new();
  //   const worksheet = XLSX.utils.json_to_sheet(DataTable);
  //   const colWidths = DataTable.reduce((acc: number[], row: any) => {
  //     Object.keys(row).forEach((key, index) => { debugger
  //       // const cellValue = row[key]?.toString() || "";
  //       // console.log('cellevalue',cellValue);
  //       const columnWidth = key.length + 5;   
  //       if (!acc[index] || columnWidth > acc[index]) {
  //         acc[index] = columnWidth;
  //       }
  //     });
  //     return acc;
  //   }, []);
  //   worksheet['!cols'] = colWidths.map((width: number) => ({ width }));
  //   XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
  //   const dataURL = XLSX.write(workbook, { type: 'base64' });
  //   const blob = this.base64toBlob(dataURL, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
  //   const link = document.createElement('a');
  //   link.href = URL.createObjectURL(blob);
  //   link.download = filename + ".xlsx";
  //   link.click();
  // }

  base64toBlob(base64: string, mimeType: string): Blob {
    const byteCharacters = atob(base64);
    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += 512) {
      const slice = byteCharacters.slice(offset, offset + 512);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    return new Blob(byteArrays, { type: mimeType });
  }

  downloadExcel(FileName: string) {
    // const link = document.createElement('a');
    // link.setAttribute('target', '_blank');
    // const fileName = FileName + ".xlsx";
    // const filePath = 'assets/SampleFormatForUpload/' + fileName;
    // link.setAttribute('href', filePath);
    // document.body.appendChild(link);
    // link.click();
    // document.body.removeChild(link);
    const fileName = FileName + ".xlsx";
    const filePath = 'assets/SampleFormatForUpload/' + fileName;

    const link = document.createElement('a');
    link.href = filePath;
    link.download = fileName;
    link.style.display = 'none';

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    setTimeout(() => {
      if (window.opener) {
        window.close();
      }
    }, 1000);
  }

  ESS_ExcelDump(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_BlukUpload/Select`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  exportToExcelWithProgress(
    data: any[],
    filename: string,
    progressCallback?: (progress: number) => void
  ): Promise<void> {
    return new Promise((resolve, reject) => {
      try {
        const workbook = XLSX.utils.book_new();
        const headers = Object.keys(data[0]);
        const totalRows = data.length;
        const CHUNK_SIZE = 10000;

        let currentRow = 0;
        const worksheetData: any[] = [];

        // Process in chunks with progress updates
        while (currentRow < totalRows) {
          const chunk = data.slice(currentRow, currentRow + CHUNK_SIZE);
          worksheetData.push(...chunk);
          currentRow += CHUNK_SIZE;

          // Update progress
          if (progressCallback) {
            const progress = Math.round((currentRow / totalRows) * 100);
            progressCallback(Math.min(progress, 100));
          }
        }

        // Create final worksheet
        const worksheet = XLSX.utils.json_to_sheet(worksheetData);
        this.autoFitColumns(worksheet, worksheetData, headers);
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

        // Download
        this.downloadWorkbook(workbook, filename);

        // Complete progress
        if (progressCallback) {
          progressCallback(100);
        }

        resolve();

      } catch (error) {
        reject(error);
      }
    });
  }

  private autoFitColumns(
    worksheet: XLSX.WorkSheet,
    data: any[],
    headers: string[]
  ): void {
    // Calculate maximum width for each column
    const colWidths = headers.map((header, colIndex) => {
      let maxLength = header.length;

      // Check data in this column
      data.forEach(row => {
        const cellValue = row[header];
        if (cellValue !== null && cellValue !== undefined) {
          const cellLength = String(cellValue).length;
          if (cellLength > maxLength) {
            maxLength = cellLength;
          }
        }
      });

      // Add padding and limit maximum width
      return { width: Math.min(Math.max(maxLength + 2, 10), 50) };
    });

    // Apply column widths to worksheet
    worksheet['!cols'] = colWidths;
  }

  private downloadWorkbook(workbook: XLSX.WorkBook, filename: string): void {
    try {
      // Generate Excel file
      const excelBuffer = XLSX.write(workbook, {
        bookType: 'xlsx',
        type: 'array'
      });

      // Create blob
      const blob = new Blob([excelBuffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });

      // Create download link
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `${filename}.xlsx`;

      // Trigger download
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // Clean up
      window.URL.revokeObjectURL(url);

    } catch (error) {
      console.error('Error downloading workbook:', error);
      throw error;
    }
  }
}
